export const EXPENSE_TYPE_OPTIONS = [
  { value: "office_material", label: "Office Material Expense" },
  { value: "gst_invoices", label: "GST invoices uploading" },
  { value: "tds_deducted", label: "TDS deducted" },
  { value: "third_party_vendor", label: "Third Party Vendor" },
  { value: "third_party_infra", label: "Third Party Payment - Infra" },
  { value: "third_party_hardware", label: "Third Party Payment - Hardware" },
  { value: "office_event", label: "Office Event Expense" },
  { value: "contractor_payment", label: "Contractor Payment" },
  { value: "freelancer_payment", label: "Freelancer Payment" },
  { value: "__other__", label: "Other" },
];

export const EXPENSE_TYPE_OTHER = "__other__";

export const OFFICE_EXPENSE_TYPE_VALUES = new Set(["office_material", "office_event"]);

export const OFFICE_EXPENSE_TYPE_OPTIONS = EXPENSE_TYPE_OPTIONS.filter((item) =>
  OFFICE_EXPENSE_TYPE_VALUES.has(item.value)
);

export const GENERAL_EXPENSE_TYPE_OPTIONS = EXPENSE_TYPE_OPTIONS.filter(
  (item) => !OFFICE_EXPENSE_TYPE_VALUES.has(item.value)
);

export const isOfficeExpenseType = (expenseType) => OFFICE_EXPENSE_TYPE_VALUES.has(expenseType);

export const getExpenseTypeOptionsForSection = (section) =>
  section === "office" ? OFFICE_EXPENSE_TYPE_OPTIONS : GENERAL_EXPENSE_TYPE_OPTIONS;

export const filterExpensesBySection = (expenses, section) => {
  const list = Array.isArray(expenses) ? expenses : [];
  if (section === "office") {
    return list.filter((item) => isOfficeExpenseType(item.expenseType));
  }
  if (section === "list") {
    return list.filter((item) => !isOfficeExpenseType(item.expenseType));
  }
  return list;
};

export const PAYMENT_METHOD_OPTIONS = [
  { value: "Cash", label: "Cash" },
  { value: "Card", label: "Card" },
  { value: "UPI", label: "UPI" },
];

export const getExpenseTypeLabel = (expenseType, customExpenseType = "") => {
  if (!expenseType) return customExpenseType || "—";
  if (expenseType === EXPENSE_TYPE_OTHER) return customExpenseType || "Other";
  const match = EXPENSE_TYPE_OPTIONS.find((item) => item.value === expenseType);
  return match?.label || expenseType;
};

export const getTodayInputValue = () => new Date().toISOString().slice(0, 10);

/** Derive finance period from YYYY-MM-DD (avoids timezone shifts from Date parsing). */
export const getExpensePeriodFromDate = (dateValue) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateValue || "").slice(0, 10));
  if (!match) return null;
  return {
    year: Number(match[1]),
    month: Number(match[2]),
  };
};

export const EXPENSE_FILE_ACCEPT =
  ".pdf,.xlsx,.xls,.doc,.docx,.jpg,.jpeg,.png,.webp,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/jpeg,image/png,image/webp";

export const EXPENSE_IMAGE_ACCEPT = ".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp";
